import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.42417 0.269439C1.56667 0.0986972 1.77759 0 1.99998 0H6.99999C7.22238 0 7.4333 0.0986972 7.5758 0.269439C7.7183 0.440182 7.77767 0.665359 7.73789 0.884164L7.71407 1.01516C8.4411 1.11905 9 1.74425 9 2.5V3.25H7.25C5.59315 3.25 4.25 4.59315 4.25 6.25V11H1.5C0.671573 11 0 10.3284 0 9.5V2.5C0 1.74426 0.55889 1.11906 1.2859 1.01516L1.26208 0.884164C1.2223 0.665359 1.28167 0.440182 1.42417 0.269439ZM2.89864 1.5L3.01395 2.13416C3.07879 2.49078 3.38938 2.75 3.75185 2.75H5.24812C5.61059 2.75 5.92118 2.49078 5.98602 2.13416L6.10133 1.5H2.89864Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.25 4.5C6.2835 4.5 5.5 5.2835 5.5 6.25V12.25C5.5 13.2165 6.2835 14 7.25 14H12.25C13.2165 14 14 13.2165 14 12.25V6.25C14 5.2835 13.2165 4.5 12.25 4.5H7.25ZM7.875 7.5C7.875 7.15482 8.15482 6.875 8.5 6.875H11C11.3452 6.875 11.625 7.15482 11.625 7.5C11.625 7.84518 11.3452 8.125 11 8.125H8.5C8.15482 8.125 7.875 7.84518 7.875 7.5ZM8.5 10.375C8.15482 10.375 7.875 10.6548 7.875 11C7.875 11.3452 8.15482 11.625 8.5 11.625H11C11.3452 11.625 11.625 11.3452 11.625 11C11.625 10.6548 11.3452 10.375 11 10.375H8.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }